import React from "react";
import Skimmer from "../../core/components/Skimmer";
import RightArrow from "../../../assets/svgs/RightArrow";
import { Text } from "../../core/design-system/Text";
import { Img } from "../../core/design-system/Img";

interface ComponentProps {}

const HomeSkimmer: React.FC<ComponentProps> = (props) => {
  const data1 = [
    { userImage: "images/img_user.svg", sendMoneyText: "Send Money" },
    { userImage: "images/img_frame_14.svg", sendMoneyText: "Invest Money" },
    {
      userImage: "images/img_frame_14_red_100.svg",
      sendMoneyText: "Bank Loans",
    },
    { userImage: "images/img_bookmark.svg", sendMoneyText: "Bill Payments" },
  ];

  const data2 = [
    { userImage: "images/current-month.svg", sendMoneyText: "Current Month" },
    { userImage: "images/last-month.svg", sendMoneyText: "Last Month" },
    {
      userImage: "images/statements.svg",
      sendMoneyText: "Last 3 Months",
    },
    { userImage: "images/statements.svg", sendMoneyText: "Statements" },
  ];

  return (
    <div
      id="dashboard-container"
      className="relative z-30 flex sm:flex-col xs:flex-col md:flex-row 
      lg:flex-row xl:flex-row max-lg:flex-row max-xl:flex-row"
    >
      <div
        id="dashboard-left-container"
        className="flex flex-col gap-3 sm:w-full xs:w-full md:w-6/12 
        lg:w-6/12 xl:w-6/12 max-lg:w-6/12 max-xl:w-6/12 p-5 "
      >
        <div className="flex flex-row gap-5">
          {[0, 1].map((data, index) => (
            <div
              key={data}
              className="w-96 h-64 border bg-white-A700 border-lightGray shadow-md overflow-hidden rounded-lg"
            >
              <div className="flex flex-row h-1/3 justify-between p-4">
                <div className="flex flex-col w-9/12 ">
                  <Skimmer width="w-20" />
                  <Skimmer width="w-40" />
                </div>

                <div className="w-2/12">
                  <Skimmer width="w-10" height="h-10" type="circle" />
                </div>
              </div>

              <div
                className={`flex ${
                  index === 0 ? "bg-red-400" : "bg-black-800"
                } h-2/3 flex-col p-4`}
              >
                {[0, 1].map((account) => (
                  <div
                    key={`${account}`}
                    className="flex flex-row py-2.5 w-full justify-between 
            border-separate border-b border-dashed 
            border-darkGray bottom-1 
            items-baseline hover:cursor-pointer"
                  >
                    <div className="flex flex-col w-10">
                      <Skimmer width="w-20" />
                      <Skimmer width="w-40" />
                    </div>

                    <RightArrow color="white" />
                  </div>
                ))}

                <div className="flex justify-center items-center">
                  <p className="text-white-A700 text-xs font-medium text-center pt-2">
                    View all accounts
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {["services", "transactions"].map((data, index) => (
          <div
            key={index}
            className="flex flex-col items-center gap-[13px] rounded-[12px] border border-solid border-blue_gray-50_02 bg-gray-100_01 pt-[17px]"
          >
            <div className="flex w-[94%] flex-wrap items-start justify-between gap-5 md:w-full md:px-5">
              <Text size="xl" as="p">
                {data}
              </Text>
              <Text as="p" className="!text-red-400 hover:cursor-pointer">
                View all
              </Text>
            </div>

            <div className="flex w-[95%] h-3/3 gap-5 md:w-full md:px-5">
              {(data === "services" ? data1 : data2).map((d, index) => (
                <div
                  key={"servicesList" + index}
                  className="flex w-full flex-col items-center gap-4 rounded-[16px] border border-solid border-blue_gray-50_02 bg-white-A700 px-4 pb-[22px] pt-8 sm:pb-5 "
                >
                  <Skimmer width="w-[44px]" height="h-[44px]" />
                  <Skimmer width="w-[80px]" />
                </div>
              ))}
            </div>

            <div className="flex items-center justify-between gap-5 self-stretch rounded-bl-[12px] rounded-br-[12px] border border-solid border-blue_gray-50_02 bg-white-A700 py-3.5 pl-[29px] pr-[19px] sm:pl-5">
              <div className="flex items-center gap-2">
                <Skimmer width="w-[18px]" height="h-[18px]" />
                <Skimmer width="w-80" />
              </div>
              <Img
                src="img_arrow_right.svg"
                alt="arrow right image"
                className="h-[20px] w-[20px] stroke-current"
                color="black-900"
              />
            </div>
          </div>
        ))}
      </div>
      <div
        id="dashboard-right-container"
        className="flex flex-col w-full pl-0 p-5 gap-3"
      >
        {/*quick transfer*/}
        <div
          itemID={"qt_1234"}
          className="flex flex-col bg-gray p-3 rounded-lg w-full border bg-gray-100_01 border-lightGray shadow-sm"
        >
          <div className="flex flex-col gap-8 bg-white-A700 p-3 rounded-lg">
            <div>
              <Skimmer width="w-40" />

              <Skimmer width="w-80" />
            </div>

            <div className="flex flex-row justify-between items-center gap-3">
              <div className="text-left w-1/3">
                <Skimmer width="w-[100px]" />
                <Skimmer width="w-40" height="h-10" />
              </div>

              <div className="text-left w-1/3">
                <Skimmer width="w-[100px]" />
                <Skimmer width="w-40" height="h-10" />
              </div>

              <div className="text-left w-1/3">
                <Skimmer width="w-[100px]" />
                <Skimmer width="w-40" height="h-10" />
              </div>
            </div>

            <div className="flex flex-row items-center gap-3">
              <div className="text-left w-1/3">
                <Skimmer width="w-[100px]" />
                <Skimmer width="w-40" height="h-10" />
              </div>

              <div className="text-left w-1/3">
                <Skimmer width="w-[100px]" />
                <Skimmer width="w-40" height="h-10" />
              </div>

              <Skimmer width="w-[100px]" height="h-[40px]" />
            </div>
          </div>
        </div>
        {/*recent transactions*/}

        <div className="flex flex-col bg-gray p-4 rounded-lg w-full border border-lightGray bg-gray-100_01 h-full">
          <div className="flex flex-col gap-8 bg-white p-3 rounded-lg bg-white-A700">
            <div>
              <div className="flex flex-row justify-between">
                <Skimmer width="w-40" />
                <Skimmer width="w-20" />
              </div>
            </div>

            <div className="flex flex-col gap-5">
              {[0, 1, 2, 3, 4].map((item, index) => {
                return (
                  <div className="flex flex-row bg-white-A700 rounded-lg border border-lightGray p-2 justify-between items-center">
                    <div className="flex flex-row gap-2 items-center">
                      <Skimmer width="w-10" height="h-10" type="circle" />
                      <div className="flex flex-col">
                        <Skimmer width="w-40" />
                        <Skimmer width="w-20" />
                      </div>
                    </div>

                    <Skimmer width="w-40" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSkimmer;
